import React from 'react';
import {
  ModalFooter as StyledModalFooter,
  TotalSection,
  TotalLabel,
  TotalPrice,
  PrimaryButton,
  SecondaryLink,
} from '../styles/modalStyles';
import { formatPrice } from '../../../../../utils/formatPrice';

export const ModalFooter = ({
  totalPrice,
  primaryButtonText,
  onPrimaryClick,
  primaryButtonDisabled = false,
  secondaryLinkText,
  onSecondaryClick,
  center = false,
  primaryButtonWidth,
  primaryButtonMarginTop,
}) => {
  return (
    <StyledModalFooter center={center}>
      {totalPrice !== undefined && (
        <TotalSection>
          <TotalLabel>TOTAL</TotalLabel>
          <TotalPrice>R${formatPrice(totalPrice)}</TotalPrice>
        </TotalSection>
      )}
      <PrimaryButton
        disabled={primaryButtonDisabled}
        onClick={() => {
          console.log('🎯 DEBUG - Primary button clicked!', primaryButtonText);
          console.log('🎯 DEBUG - onPrimaryClick function:', onPrimaryClick);
          if (onPrimaryClick) {
            onPrimaryClick();
          } else {
            console.error('❌ DEBUG - onPrimaryClick is not defined!');
          }
        }}
        width={primaryButtonWidth}
        marginTop={primaryButtonMarginTop}
      >
        {primaryButtonText}
      </PrimaryButton>
      {secondaryLinkText && (
        <SecondaryLink onClick={onSecondaryClick}>{secondaryLinkText}</SecondaryLink>
      )}
    </StyledModalFooter>
  );
};
